<template>
	<div class="duty-head">
		<div class="duty-head-left">
			<h2>{{ formatSecondsDuration(props.duty.start) }}</h2>
			<p>{{ duty.startStop }}</p>
		</div>

		<v-divider class="horizontal-divider" />

		<div class="duty-head-center">
			<div>
				<h2>{{ $t('duration') }}</h2>
				<p v-if="!props.duty.dutyTime">-</p>
				<p v-else>{{ formatSecondsDuration(props.duty.dutyTime) }}</p>

				<v-chip class="ma-2 break-chip" size="small" variant="flat">
					<v-icon left>mdi-pause-circle-outline</v-icon>
					<span class="ml-2">{{ props.duty.breakCount }}</span>
				</v-chip>
			</div>
		</div>

		<v-divider class="horizontal-divider" />

		<div class="duty-head-right">
			<h2>{{ formatSecondsDuration(props.duty.end) }}</h2>
			<p>{{ props.duty.endStop }}</p>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { ApiDuty } from '@/rennovation/planning-view/types/api/duties-response';
import useDateTime from '../../../../../../../components/composables/useDateTime.js';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
	defineProps<{
		duty: ApiDuty;
	}>(),
	{}
);

const { formatSecondsDuration } = useDateTime();
const { t } = useI18n();
</script>
<style scoped>
.duty-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.duty-head-left,
.duty-head-center,
.duty-head-right {
	align-self: flex-start;
	text-align: center;
	padding: 12px 16px;
}

.duty-head-center {
	flex: 1;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: center;
}

.duty-head-center > div {
	flex: 0 0 auto;
}

.duty-head-center p {
	padding: 0px 20px;
	margin-bottom: 0px;
}

.duty-line {
	flex: 1 1 0%;
	min-width: 24px;
	height: 2px;
	margin-bottom: 10px;
	border-radius: 5px;
	background: #e0e0e0;
}

.break-chip {
	width: 40px;
	height: 16px;
	min-width: 40px;
	border-radius: 10px;
	opacity: 1;
	gap: 6px;
	padding-right: 8px;
	padding-left: 8px;
	background-color: #ff5252 !important;
	color: #ffffff !important;
}

.break-chip .v-icon {
	font-size: 10px;
	color: #ffffff !important;
}
.break-chip-container {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
}
.horizontal-divider {
	width: 50px;
}
</style>
